import React from 'react';

import { Box } from '@mui/material';

import { spaces } from '../../../../../assets/styles/themes/tokens';

const MuiCardBaseShortDetails: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: spaces.sm,
    }}
    data-testid='mui-card-mobile__truncated-section'
  >
    {children}
  </Box>
);

export default MuiCardBaseShortDetails;
